import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { FormControl, Typography, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { YesNoSelector } from '@fnol/library/src/components';
import { constValues, driverSelection, legalPersonType, personType, translations } from '../../lib/consts';
import { removeEmptyProperties } from '../../lib/helpers';
import { IndividualCleanup } from '../Individual/Individual';
import Individual from '../Individual';

const DriverSection = () => {
    const { values, errors, touched, setFieldValue } = useFormikContext<any>();

    const DRIVER_OPTIONS = [
        {
            id: driverSelection.submitter,
            value: `${values.submitterIndividualName} ${values.submitterIndividualLastName}`,
        },
        {
            id: driverSelection.owner,
            value: `${values.ownerIndividualName} ${values.ownerIndividualLastName}`,
        },
        {
            id: driverSelection.user,
            value: `${values.userIndividualName} ${values.userIndividualLastName}`,
        },
        { id: driverSelection.other, value: translations.ADD_CONTACT },
    ];

    const filterEmptyValues = removeEmptyProperties(DRIVER_OPTIONS);

    const handleChangeDriver = (e: { target: { value: any } }): any => {
        setFieldValue('pickDriver', e.target.value);
        IndividualCleanup(personType.driver, setFieldValue);
    };

    const handleChangeIsVehicleParked = () => {
        setFieldValue('pickDriver', '');
        IndividualCleanup(personType.driver, setFieldValue);
    };

    const driverSelected = (): driverSelection => {
        let result = driverSelection.initialValue;
        if (values['submitterIndividualPersonRoleId'] === constValues.driver) result = driverSelection.submitter;
        else if (values['ownerIndividualPersonRoleId'] === constValues.driver) result = driverSelection.owner;

        return result;
    };

    useEffect(() => {
        const driverSelector = driverSelected();
        setFieldValue('driver', driverSelector);

        if (driverSelector !== driverSelection.initialValue) {
            setFieldValue('pickDriver', driverSelector);
            setFieldValue('isVehicleParked', 'false');
        }
    }, [values['submitterIndividualPersonRoleId'], values['ownerIndividualPersonRoleId']]);

    return (
        <>
            {values.driver === driverSelection.initialValue && (
                <>
                    <Typography style={{ fontWeight: 'bold', fontSize: '18px', paddingTop: '8px' }} variant="subtitle1">
                        {translations.driver.DRIVER}
                    </Typography>
                    <Typography variant="subtitle1">{translations.driver.IS_VEHICLE_PARKED}</Typography>
                    <YesNoSelector name="isVehicleParked" onChange={handleChangeIsVehicleParked} />
                    {values.driverType === legalPersonType.individual && values.isVehicleParked === 'false' && (
                        <>
                            <FormControl>
                                <InputLabel id="pick-driver-label">{translations.driver.PICK_DRIVER}</InputLabel>

                                <Select
                                    id="pick-driver"
                                    labelId="pick-driver-label"
                                    name="pickDriver"
                                    value={values.pickDriver || ''}
                                    label={translations.driver.PICK_DRIVER}
                                    error={!!(touched.pickDriver && errors.pickDriver)}
                                    onChange={handleChangeDriver}
                                >
                                    {filterEmptyValues.map((option: any) => {
                                        return (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.value}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>

                                {touched.pickDriver && errors.pickDriver ? (
                                    <FormHelperText error={true}>
                                        <>{errors.pickDriver}</>
                                    </FormHelperText>
                                ) : null}
                            </FormControl>
                            {values.pickDriver === driverSelection.other && (
                                <Individual individualType={personType.driver} />
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default DriverSection;
